<template>
  <div class="stat-filter--dates">
    <div>
      <TimezoneSelector v-model="timezone.value" />
    </div>
    <RadioChoice :items="radio.choice.fields" group="choice-range" v-model="radio.value" @change="onRadioChoice" />
    <date-picker
        v-if="pickerEnabled"
        :lang="picker.lang"
        v-model="picker.value"
        type="date"
        range
        format="DD/MM/YYYY"
        title-format="DD/MM/YYYY"
        time-title-format="DD/MM/YYYY"
        :shortcuts="withShortcuts ? picker.shortcuts : []"
    >
      <template v-slot:icon-calendar>
        <span class="icon-calendar"></span>
      </template>
    </date-picker>
  </div>
</template>

<script>
import RadioChoice from '@/components/RadioChoice';
import TimezoneSelector from '@/components/TimezoneSelector.vue';
import DatePicker from 'vue2-datepicker';

function setToLastDateInMonth(date) {
  date.setDate(1);
  date.setMonth(date.getMonth() + 1);
  date.setDate(date.getDate() - 1);
}

function getDatesRange(type) {
  switch (type) {
    case 'today':
      return [new Date(), new Date()];
    case 'yesterday': {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return [date, date];
    }
    case 'last_7_days': {
      const from = new Date();
      from.setDate(from.getDate() - 6);

      return [from, new Date()];
    }
    case 'this_month': {
      const from = new Date();
      from.setDate(1);

      return [from, new Date()];
    }
    case 'prev_month': {
      const from = new Date();
      const to = new Date();

      let newMonth = from.getMonth() > 0 ? from.getMonth() - 1 : 11;
      if (newMonth === 11) {
        from.setFullYear(from.getFullYear() - 1);
        to.setFullYear(from.getFullYear());
      }

      from.setDate(1);
      from.setMonth(newMonth);

      to.setMonth(newMonth);

      setToLastDateInMonth(to);

      return [from, to];
    }
    default:
      throw new Error(`Wrong value ${type}`);
  }
}

export default {
  name: 'ChoiceRange',
  props: {
    pickerEnabled: {},
    withShortcuts: {},
    tz: {},
  },
  components: {
    TimezoneSelector,
    DatePicker,
    RadioChoice,
  },
  data: function() {
    return {
      radio: {
        value: 'today',
        choice: {
          fields: [
            {
              name: 'today',
              title: 'Сегодня',
            },
            {
              name: 'yesterday',
              title: 'Вчера',
            },
            {
              name: 'last_7_days',
              title: '7 Дней',
            },
          ],
        },
      },
      picker: {
        value: [],
        lang: {
          formatLocale: {
            firstDayOfWeek: 1,
          },
          monthBeforeYear: false,
        },
        shortcuts: [
          {
            text: 'Сегодня',
            onClick: () => getDatesRange('today'),
          },
          {
            text: 'Вчера',
            onClick: () => getDatesRange('yesterday'),
          },
          {
            text: '7 Дней',
            onClick: () => getDatesRange('last_7_days'),
          },
          {
            text: 'Текущий месяц',
            onClick: () => getDatesRange('this_month'),
          },
          {
            text: 'Прошлый месяц',
            onClick: () => getDatesRange('prev_month'),
          },
        ],
      },
      lastRange: {
        from: new Date(),
        to: new Date(),
      },
      timezone: {
        value: this.tz,
      },
    };
  },
  methods: {
    onRadioChoice(value) {
      this.radio.value = value;
      const range = getDatesRange(value);
      this.lastRange = {
        from: range[0],
        to: range[1],
      };
      this.$emit('change', [...range, this.timezone.value]);
    },
  },
  watch: {
    'picker.value': {
      immediate: false,
      handler(val) {
        const [from, to] = val;
        this.lastRange = {
          from,
          to,
        };
        this.$emit('change', [from, to, this.timezone.value]);
      },
    },
    'timezone.value': {
      immediate: false,
      handler(val) {
        this.$emit('change', [this.lastRange.from, this.lastRange.to, val]);
      },
    },
  },
};
</script>
